"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCarousel = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
exports.StyledCarousel = styled_1.default.div `
    position: relative;
    margin-left: -10px;
    width: calc(100% + 20px);

    &::after {
        content: "";
        right: 0;
        top: 0;
        bottom: 0;
        background: linear-gradient(to left, #fffc, #fff0);
        position: absolute;
        width: 20%;
        pointer-events: none;
    }

    .carousel-scroller {
        max-width: 100%;
        position: relative;
        overflow-x: scroll;
    }

    .carousel-inner {
        display: flex;
        justify-content: space-between;
        padding: 0 10px;
    }
`;
//# sourceMappingURL=Carousel.styled.js.map